import logger from './rbata.logger';

const mediaLazyLoad = {
    lazyAttribute:          'lazy',
    dynamicAttribute:       'lazydynamic', //use this when content is dynamic
    animatedAttribute:      'animated',
    cloudinarySource:       'data-cld-src',
    lazyLoadPool:           [],
    lazyLoadPoolCloudinary: [],
    $lazyItem:              undefined,
    observer:               undefined,
    cloudinaryObserver:     undefined,
    tag:                    {img: 'IMG', video: 'VIDEO'},
    initialSrc:             'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    options:                {
        rootMargin: '0px',
        threshold:  [0, 0.05, 0.1]
    },

    /**
     * When called this method will select all images with lazy attribute and put them into pool
     * You can pass prefix for selector to focus down detection
     */
    scanLazyImages(preSelector = '') {
        this.lazyLoadPool =
                document.querySelectorAll(
                        `${preSelector} img[${this.lazyAttribute}], ${preSelector} video[${this.lazyAttribute}], ${preSelector} img[${this.dynamicAttribute}], ${preSelector} video[${this.dynamicAttribute}]`
                );
    },

    /**
     * This will create observer object, call method for scanning all images and
     * bind observer to that images.
     */
    init() {
        this.scanLazyImages();
        if (!this.observer) {
            this.observer = new IntersectionObserver(this.observerActions, this.options);
        }
        if (this.lazyLoadPool.length) {
            this.bindObserver(this.lazyLoadPool, this.observer)
        } else {
            logger.log(`No lazy images in the pool.`)
        }
    },

    cloudinaryLazyLoadInit(elements) {
        this.lazyLoadPoolCloudinary = elements;
        if (this.lazyLoadPoolCloudinary.length) {
            if (this.cloudinaryObserver) {
                this.cloudinaryObserver.disconnect();
            }
            this.cloudinaryObserver = new IntersectionObserver(this.observerActions, this.options);
            this.bindObserver(this.lazyLoadPoolCloudinary, this.cloudinaryObserver)
        } else {
            logger.log(`No cloudinary lazy images in the pool.`)
        }
    },

    /**
     * Binds observer to all images from the pool (pool can be refreshed anytime)
     */
    bindObserver(imagePool, observer) {
        imagePool.forEach(item => {
            observer.observe(item);
            if (!item.hasAttribute(this.dynamicAttribute)) {
                item.removeAttribute(this.lazyAttribute);
            }

        })
    },

    /**
     * Obeserver actions on observed object behaviour
     * on threshold of 0, source for img will be automatically provided
     * on threshold of 0.1 animation is executed if element has attribute animated
     * lazy and animated attributes are cleaned up from object once all logic fulfilled
     * @param entries
     * @param observer
     */
    observerActions(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                //If it is image and it's loaded then it
                if (entry.target.hasAttribute(mediaLazyLoad.animatedAttribute) && entry.target.tagName === mediaLazyLoad.tag.img) {
                    entry.target.onload = function () {
                        entry.target.removeAttribute(mediaLazyLoad.animatedAttribute);
                        observer.unobserve(entry.target);
                    };
                }

                // apply animation if has attribute and threshold matched and it's video
                if (entry.target.hasAttribute(mediaLazyLoad.animatedAttribute)
                        && entry.intersectionRatio >= 0.1
                        && entry.target.tagName === mediaLazyLoad.tag.video) {
                    entry.target.removeAttribute(mediaLazyLoad.animatedAttribute);
                    observer.unobserve(entry.target);
                }

                //unbind watcher if no animated attribute, no point keeping observer anymore
                if (entry.target.hasAttribute(mediaLazyLoad.animatedAttribute) === false) {
                    entry.target.onload = function () {
                        observer.unobserve(entry.target);
                    }
                }

                //exchange source anyway
                entry.target.dataset.cldSrc ?
                        entry.target.setAttribute('src', entry.target.dataset.cldSrc) :
                        entry.target.setAttribute('src', entry.target.dataset.src);
            }
        });
    },

    /**
     * Call this method to pool new objects with lazy attribute if needed
     * DO NOT USE FOR CLOUDINARY - there is no need for it
     */
    refreshLazyLoad(preSelector='') {
        setTimeout(() => {
            this.scanLazyImages(preSelector);
            if (this.observer) {
                this.bindObserver(this.lazyLoadPool, this.observer);
            }
        }, 0)
    }
}

/**
 * Immediate init of method once page starts loading
 */

mediaLazyLoad.init();

export default mediaLazyLoad;